module.exports = __webpack_public_path__ + "img/bg_map.807172a7.png";